import { render, staticRenderFns } from "./I-0-2__IR-Default messaging.vue?vue&type=template&id=b97a7f48&"
import script from "./I-0-2__IR-Default messaging.vue?vue&type=script&lang=js&"
export * from "./I-0-2__IR-Default messaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports